module.exports = __webpack_public_path__ + "img/instagramestory4.a12e78b0.jpg";